/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedUser } from './ExtendedUser';
import { SessionRestrictionData } from './SessionRestrictionData';
const UserLoginResponseParser = /* #__PURE__ */ parsers.object([
    ['user', ExtendedUser],
    ['accessToken', codecString, 'access_token'],
    ['restrictions', SessionRestrictionData],
    ['expiresAt', parsers.moment, 'expires_at'],
]);
export class UserLoginResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UserLoginResponseParser.decode(input).map(res => new UserLoginResponse(res));
    }
    static unsafeDecode(input) {
        return UserLoginResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UserLoginResponseParser.encode(data);
    }
    static schema() {
        return UserLoginResponseParser.schema();
    }
}
